import React from "react"
import { MainCP } from "../../Components/recordatorio-espontaneo-marcas-festival2024/MainCP"

const ViewRecordatorioEspontaneoMarcaFestival2024: React.FC = () => <MainCP/>

export default ViewRecordatorioEspontaneoMarcaFestival2024